import { apiClient } from "./client";
import type {
  User,
  UserCreate,
  UserUpdate,
  UsersPaginated,
  UserRole,
  MessageResponse,
} from "@/types";

interface ListUsersParams {
  page?: number;
  pageSize?: number;
  search?: string;
  role?: UserRole;
  is_active?: boolean;
}

export async function listUsers(params: ListUsersParams = {}): Promise<UsersPaginated> {
  const response = await apiClient.get<UsersPaginated>("/users", { params });
  return response.data;
}

export async function getUser(userId: number): Promise<User> {
  const response = await apiClient.get<User>(`/users/${userId}`);
  return response.data;
}

export async function createUser(data: UserCreate): Promise<User> {
  const response = await apiClient.post<User>("/users", data);
  return response.data;
}

export async function updateUser(userId: number, data: UserUpdate): Promise<User> {
  const response = await apiClient.patch<User>(`/users/${userId}`, data);
  return response.data;
}

export async function deleteUser(userId: number): Promise<MessageResponse> {
  const response = await apiClient.delete<MessageResponse>(`/users/${userId}`);
  return response.data;
}

export async function updateMe(data: Partial<User>): Promise<User> {
  const response = await apiClient.patch<User>("/users/me", data);
  return response.data;
}

export async function updatePassword(
  currentPassword: string,
  newPassword: string
): Promise<{ message: string }> {
  const response = await apiClient.patch<{ message: string }>("/users/me/password", {
    current_password: currentPassword,
    new_password: newPassword,
  });
  return response.data;
}

export async function listShareableUsers(search?: string): Promise<User[]> {
  const params = search && search.trim() ? { search: search.trim() } : undefined;
  const response = await apiClient.get<User[]>("/users/shareable", { params });
  return response.data;
}

